/**
 * Jobs — client-side categorie-filtering.
 *
 * Dunne wrapper op de gedeelde filter-module (resources/js/filter.js): dit blok
 * levert z'n eigen .jobs__* selectors. Import in resources/js/main.js; self-init
 * op DOM-ready.
 */
import { initFilter } from '../../resources/js/filter.js';

const CONFIG = {
    block: '.jobs',
    filter: '.jobs__filter',
    card: '.jobs__card',
    hiddenClass: 'jobs__card--hidden',
};

/**
 * Initialiseert alle jobs-blokken binnen een scope.
 *
 * @param {ParentNode} [scope] - Zoekwortel (default: document).
 */
export function initJobs(scope = document) {
    initFilter(CONFIG, scope);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initJobs());
} else {
    initJobs();
}
